// Routes del módulo deals. Cada tab del sidebar mapea a una vista de la app
// «Deals» del SO Orion (misma app, pestaña distinta):
//
//   /m/deals/kanban     → Pipeline (tablero por etapa + ficha ?deal=<id>)
//   /m/deals/forecast   → Forecast (tiles + por etapa / por mes)
//   /m/deals/create     → Nuevo deal

import { DealsApp } from './components/DealsApp';

export function DealKanbanView() {
  return <DealsApp view="kanban" />;
}

export function DealForecastView() {
  return <DealsApp view="forecast" />;
}

export function DealCreateView() {
  return <DealsApp view="create" />;
}
